import PropTypes from 'prop-types'

export default {
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  options: PropTypes.array.isRequired,
  label: PropTypes.func.isRequired,
  active: PropTypes.func.isRequired,
  classNames: PropTypes.shape({
    wrapper: PropTypes.string,
    trigger: PropTypes.string,
    option: PropTypes.string,
  }),
  children: PropTypes.func,
}
